/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentRuleScope } from './AssignmentRuleScope';
import {
    AssignmentRuleScopeFromJSON,
    AssignmentRuleScopeFromJSONTyped,
    AssignmentRuleScopeToJSON,
    AssignmentRuleScopeToJSONTyped,
} from './AssignmentRuleScope';
import type { ApiUser } from './ApiUser';
import {
    ApiUserFromJSON,
    ApiUserFromJSONTyped,
    ApiUserToJSON,
    ApiUserToJSONTyped,
} from './ApiUser';
import type { SourceTag } from './SourceTag';
import {
    SourceTagFromJSON,
    SourceTagFromJSONTyped,
    SourceTagToJSON,
    SourceTagToJSONTyped,
} from './SourceTag';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
    SourceToJSONTyped,
} from './Source';

/**
 * 
 * @export
 * @interface AssignmentRule
 */
export interface AssignmentRule {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    scope: AssignmentRuleScope;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    source_id?: string;
    /**
     * 
     */
    connector?: string;
    /**
     * 
     */
    owner_user_id: string;
    /**
     * 
     */
    liaison_user_ids: Array<string>;
    /**
     * 
     */
    priority: number;
    /**
     * 
     */
    created_by_user_id: string;
    /**
     * 
     */
    created_at: string;
    /**
     * 
     */
    updated_at?: string;
    /**
     * 
     */
    facility?: SourceTag;
    /**
     * 
     */
    source?: Source;
    /**
     * 
     */
    owner_user?: ApiUser;
    /**
     * 
     */
    created_by_user?: ApiUser;
    /**
     * 
     */
    liaison_users?: Array<ApiUser>;
}



/**
 * Check if a given object implements the AssignmentRule interface.
 */
export function instanceOfAssignmentRule(value: object): value is AssignmentRule {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('owner_user_id' in value) || value['owner_user_id'] === undefined) return false;
    if (!('liaison_user_ids' in value) || value['liaison_user_ids'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('created_by_user_id' in value) || value['created_by_user_id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function AssignmentRuleFromJSON(json: any): AssignmentRule {
    return AssignmentRuleFromJSONTyped(json, false);
}

export function AssignmentRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignmentRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'scope': AssignmentRuleScopeFromJSON(json['scope']),
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'source_id': json['source_id'] == null ? undefined : json['source_id'],
        'connector': json['connector'] == null ? undefined : json['connector'],
        'owner_user_id': json['owner_user_id'],
        'liaison_user_ids': json['liaison_user_ids'],
        'priority': json['priority'],
        'created_by_user_id': json['created_by_user_id'],
        'created_at': json['created_at'],
        'updated_at': json['updated_at'] == null ? undefined : json['updated_at'],
        'facility': json['facility'] == null ? undefined : SourceTagFromJSON(json['facility']),
        'source': json['source'] == null ? undefined : SourceFromJSON(json['source']),
        'owner_user': json['owner_user'] == null ? undefined : ApiUserFromJSON(json['owner_user']),
        'created_by_user': json['created_by_user'] == null ? undefined : ApiUserFromJSON(json['created_by_user']),
        'liaison_users': json['liaison_users'] == null ? undefined : ((json['liaison_users'] as Array<any>).map(ApiUserFromJSON)),
    };
}

export function AssignmentRuleToJSON(json: any): AssignmentRule {
    return AssignmentRuleToJSONTyped(json, false);
}

export function AssignmentRuleToJSONTyped(value?: AssignmentRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'scope': AssignmentRuleScopeToJSON(value['scope']),
        'facility_id': value['facility_id'],
        'source_id': value['source_id'],
        'connector': value['connector'],
        'owner_user_id': value['owner_user_id'],
        'liaison_user_ids': value['liaison_user_ids'],
        'priority': value['priority'],
        'created_by_user_id': value['created_by_user_id'],
        'created_at': value['created_at'],
        'updated_at': value['updated_at'],
        'facility': SourceTagToJSON(value['facility']),
        'source': SourceToJSON(value['source']),
        'owner_user': ApiUserToJSON(value['owner_user']),
        'created_by_user': ApiUserToJSON(value['created_by_user']),
        'liaison_users': value['liaison_users'] == null ? undefined : ((value['liaison_users'] as Array<any>).map(ApiUserToJSON)),
    };
}

